module.exports = __webpack_public_path__ + "img/overview2.0f1e8e14.jpg";